<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-contractors-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-contractors-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-contractors-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                                  [disableRouterLink]="true"
                                  [filters]="filters">
    </app-contractors-list>
  </ng-template>
</div>